import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { OfbizList, RemoteFormData, ColumnFieldTitle, OfbizField } from '@urbannex/ofbiz-forms';
import { getFields, getColumnFieldTitles } from '@urbannex/view-containers';
import { PART_FORMS } from '../../../../forms';

@Component({
  selector: 'pty-customer-email',
  templateUrl: './cutomer-email.component.html',
  styleUrls: ['./cutomer-email.component.scss']
})
export class CutomerEmailComponent implements OnChanges{
  @Input() partyId:string;
  listForm:OfbizList;

  title:"PostalAddresses";
  fieldOptions:any;
  state$:any;
  isLookup:false;
  cardMode:true;
  remoteFormData:RemoteFormData;
  columnFieldTitles:ColumnFieldTitle[];
  columnFields:OfbizField[];
  listOptions:any;
  hasRemoteData = false;

  constructor(){}

  ngOnChanges(changes: SimpleChanges): void {
    if(changes["partyId"]){
      this.listForm = new OfbizList({
        listFormName:"CustomerEmailAddress",
        listFormLocation: "component://kwikstore/widget/PartyForms.xml",
        columnFields: getFields("CustomerEmailAddress", PART_FORMS),
        columnFieldTitles:getColumnFieldTitles("CustomerEmailAddress",PART_FORMS),
        //fieldFormFields:any,
        listType:"grid",
        emptyListMessage:"No Postal Addresses found for this customer",
        remoteFormData:{
          formData:{
            formName:"CustomerEmailAddress",
            formLocation:"component://kwikstore/widget/PartyForms.xml",
            viewIndex:0,
            listType:"grid",
          },
          parameters:{"partyId":this.partyId},
          endPoint:"partymgr"
        }
      })
      this.remoteFormData = {
        formData:{
          formName:"CustomerEmailAddress",
          formLocation:"component://kwikstore/widget/PartyForms.xml",
          viewIndex:0,
          listType:"grid",
        },
        parameters:{"partyId":this.partyId},
        endPoint:"partymgr"
      };
      this.columnFields = getFields("CustomerEmailAddress",PART_FORMS),
      this.columnFieldTitles = getColumnFieldTitles("CustomerEmailAddress",PART_FORMS),
      this.state$.remoteFormData = this.remoteFormData;
      this.hasRemoteData = true;
      console.log(this.remoteFormData);     
    }
  }

  handleHyperLinkSelected(e){

  }

  handleListSucessNotify(e){

  }

  showOverview(e){

  }

  showEditDialog(e){

  }
  
}
